<template>
  <div>
    <div v-if="report.length > 0" class="mt-3">
      <h3 class="text-center">Оборот ягод</h3>
      <table class="table fs-8 table-bordered" id="report-print">
        <thead>
          <tr>
            <th></th>
            <th colspan="5">Принято, кг</th>
            <th colspan="3">Передано ФБ, кг</th>
            <th>Остаток, кг</th>
          </tr>
          <tr>
            <th>
              <span v-if="selectedBerry">
                Оптовик
              </span>
              <span v-else>
                Ягода
              </span>
            </th>
            <th>Всего</th>
            <th>Усушка</th>
            <th>Сухой</th>
            <th>Средняя цена, руб</th>
            <th>Сумма, руб</th>
            <th>Сухой</th>
            <th>Средняя цена, руб</th>
            <th>Сумма, руб</th>
            <th>Сухой</th>

            <th>Усушка, руб/кг</th>
            <th>Бонус оптовик, руб/кг</th>
            <th>Бонус точка, руб/кг</th>
            <th>Логистика, руб/кг</th>
            <th>Доп затраты, руб/кг</th>

            <th>Общая выручка, с затратами руб/кг</th>
            <th>Общая выручка, вместе со всеми затратами СУММА</th>
            <th>Заработок точки оптовика (бонус) СУММА</th>
            <th>Заработок оптовика (бонус) СУММА</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(berry, index) in report" :key="index">
            <td>
              <button
                class="btn btn-light"
                @click="changeCurrentBerry(berry)"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#berry-${berry.berryId}`"
                aria-expanded="true"
                :aria-controls="`berry-${berry.berryId}`"
              >
                <span v-if="selectedBerry">
                  {{ berry.receiverLabel }}
                </span>
                <span v-else>
                  {{ berry.berryLabel }}
                </span>
              </button>
              <button
                v-if="showWriteoffBtn && !berry.spinnerWriteoffBalace && isAdmin"
                class="btn btn-sm btn-secondary"
                @click="writeoffBalace(berry)"
              >
                Списать остаток
              </button>

              <div v-if="berry.spinnerWriteoffBalace" class="d-flex justify-content-center mt-3">
                <div
                  class="spinner-border text-primary d-flex justify-content-center"
                  role="status"
                ></div>
              </div>
            </td>
            <td>
              {{
                Number(berry.resultAcceptance.weightSum.total)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td data-label="Принято усушка">
              {{
                Number(berry.resultAcceptance.weightShrink.total)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td data-label="Принято сухой">
              {{
                Number(berry.resultAcceptance.weightDry.total)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td data-label="Принято средняя цена">
              {{
                Number(berry.resultAcceptance.priceAvg)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td data-label="Принято сумма"> 
              {{
                Number(berry.resultAcceptance.sum)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td data-label="Передано ФБ сухой">
              {{
                Number(berry.resultTransfer.weightDry)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td data-label="Передано ФБ средняя цена">
              {{ berry.resultTransfer.priceAvg.toFixed(2) }}
            </td>
            <td data-label="Передано ФБ сумма">{{ berry.resultTransfer.sum.toFixed(2) }}</td>
            <td data-label="Остаток сухой">
              {{
                // Number(berry.resultAcceptance.weightDry.balance).toFixed(2).toLocaleString()
                Number(berry.resultAcceptance.weightDry.balanceSimple).toFixed(2).toLocaleString()
              }}
            </td>

            <td>
              {{
                Number(berry.resultTransfer.priceShrink)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td>
              {{
                Number(berry.resultTransfer.priceCompanyBonus)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td>
              {{
                Number(berry.resultTransfer.priceReceiverBonus)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td>
              {{
                Number(berry.resultTransfer.priceLogist)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td>
              {{
                Number(berry.resultTransfer.priceCost)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>

            <td>
              {{
                Number(berry.resultTransfer.revenueAvg)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td>
              {{
                Number(berry.resultTransfer.revenueSumTotal)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td>
              {{
                Number(berry.resultTransfer.bonusReceiverSumTotal)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
            <td>
              {{
                Number(berry.resultTransfer.bonusMasterSumTotal)
                  .toFixed(2)
                  .toLocaleString()
              }}
            </td>
          </tr>
          <tr class="fw-bold">
            <td>ИТОГО</td>
            <td>{{ reportSum.acceptWeightSumTotal.toFixed(2) }}</td>
            <td>{{ reportSum.acceptweightShrinkTotal.toFixed(2) }}</td>
            <td>{{ reportSum.acceptWeightDryTotal.toFixed(2) }}</td>
            <td>{{ reportSum.аcceptancePriceAvg.toFixed(2) }}</td>
            <td>{{ reportSum.аcceptanceSum.toFixed(2) }}</td>
            <td>{{ reportSum.transferWeightDryTotal.toFixed(2) }}</td>
            <td>{{ reportSum.priceAvg.toFixed(2) }}</td>
            <td>{{ reportSum.sum.toFixed(2) }}</td>
            <td>{{ reportSum.acceptWeightDryBalance.toFixed(2) }}</td>

            <td>{{ reportSum.priceShrink.toFixed(2) }}</td>
            <td>{{ reportSum.priceCompanyBonus.toFixed(2) }}</td>
            <td>{{ reportSum.priceReceiverBonus.toFixed(2) }}</td>
            <td>{{ reportSum.priceLogist.toFixed(2) }}</td>
            <td>{{ reportSum.priceCost.toFixed(2) }}</td>
            <td>{{ reportSum.revenueAvg.toFixed(2) }}</td>
            <td>{{ reportSum.revenueSumTotal.toFixed(2) }}</td>
            <td>{{ reportSum.bonusReceiverSumTotal.toFixed(2) }}</td>
            <td>{{ reportSum.bonusMasterSumTotal.toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="accordion fs-10" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              :data-bs-target="`#berry-${currentBerry.berryId}`"
              aria-expanded="true"
              :aria-controls="`berry-${currentBerry.berryId}`"
            >
              <span>Подробный расчет: </span>

              <span v-if="selectedBerry">
                {{ currentBerry.receiverLabel }}
              </span>
              <span v-else>
                {{ currentBerry.berryLabel }}
              </span>
            </button>
          </h2>
          <div
            :id="`berry-${currentBerry.berryId}`"
            class="accordion-collapse collapse"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div v-if="currentBerry" class="accordion-body">
              <div
                v-for="transfer in currentBerry.resultTransfer.transfers"
                :key="transfer._id"
                class="row"
              >
                <div class="row">
                  <router-link
                    :to="{
                      name: 'transfer',
                      params: { id: transfer._id }
                    }"
                  >
                    <span v-if="transfer.writeOff">Акт списания №</span>
                    <span v-if="!transfer.writeOff">Акт передачи №</span>
                    {{ transfer.prefix }}-{{ transfer.number }} от
                    {{ new Date(transfer.date).toLocaleString() }}
                  </router-link>
                </div>
                <div class="row">
                  <div class="row">
                    <div class="col text-muted lh-1">
                      <small>Вес сухой, кг</small>
                    </div>
                    <div class="col text-muted lh-1">
                      <small>Цена, руб</small>
                    </div>
                    <div class="col text-muted lh-1">
                      <small>Сумма, руб</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-muted lh-1">
                      <small>{{ transfer.tableUnit[0].weight }}</small>
                    </div>
                    <div class="col text-muted lh-1">
                      <small>{{ transfer.tableUnit[0].price }}</small>
                    </div>
                    <div class="col text-muted lh-1">
                      <small>{{
                        transfer.tableUnit[0].weight * transfer.tableUnit[0].price
                      }}</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-muted lh-1">
                      <small>Вес нераспред, кг</small>
                    </div>
                    <div class="col text-muted lh-1">
                      <small>Цена нераспред, руб</small>
                    </div>
                    <div class="col text-muted lh-1">
                      <small>Сумма нераспред, руб</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-muted lh-1">
                      <small>{{ transfer.weightManual }}</small>
                    </div>
                    <div class="col text-muted lh-1">
                      <small>{{ transfer.priceManual }}</small>
                    </div>
                    <div class="col text-muted lh-1">
                      <small>{{ transfer.weightManual * transfer.priceManual }}</small>
                    </div>
                  </div>

                  <div class="accordion" :id="`accordion-transfer-${transfer._id}`">
                    <div class="accordion-item">
                      <h2 class="accordion-header" :id="`heading-transfer-${transfer._id}`">
                        <button
                          class="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          :data-bs-target="`#transfer-${transfer._id}`"
                          aria-expanded="true"
                          :aria-controls="`transfer-${transfer._id}`"
                        >
                          <small>РАСЧЕТ ЦЕНЫ</small>
                        </button>
                      </h2>
                      <div
                        :id="`transfer-${transfer._id}`"
                        class="accordion-collapse collapse"
                        :aria-labelledby="`heading-transfer-${transfer._id}`"
                        :data-bs-parent="`#accordion-transfer-${transfer._id}`"
                      >
                        <div class="accordion-body">
                          <div class="row row-cols-1 pt-2">
                            <div
                              class="row"
                              v-for="(detail, index) in transfer.details"
                              :key="index"
                            >
                              <div class="row text-muted mt-1">
                                <router-link
                                  v-if="detail.acceptanceId"
                                  :to="{
                                    name: 'acceptance',
                                    params: { id: detail.acceptanceId }
                                  }"
                                >
                                  <small>{{ detail.acceptanceLabel }}</small>
                                </router-link>
                                <span v-else>{{ detail.acceptanceLabel }}</span>
                              </div>
                              <div v-if="false" class="row row-cols-3">
                                <div class="col text-muted">
                                  <small>Ставка бонус, руб</small>
                                </div>
                                <div class="col text-muted">
                                  <small>Ставка логистика, руб</small>
                                </div>
                                <div class="col text-muted">
                                  <small>Общая усушка, %</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.rateTotal.bonus }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.rateTotal.logist }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.rateTotal.shrink }}</small>
                                </div>

                                <div class="col text-muted mt-2">
                                  <small>Всего</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Закрыто</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Принято</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Вес сухой, кг</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Вес сухой, кг</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Вес сухой, кг</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.weightDry.total.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.weightDry.closed.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.weightDry.accept.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Усушка, кг</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Усушка, кг</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Усушка, кг</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.weightShrink.total.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.weightShrink.closed.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.weightShrink.accept.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма всего, руб</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма всего, руб</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма всего, руб</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumDry.total.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumDry.closed.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumDry.accept.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма усушка, руб</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма усушка, руб</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма усушка, руб</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumShrink.total.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumShrink.closed.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumShrink.accept.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма логистика, руб</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма логистика, руб</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма логистика, руб</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumLogist.total.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumLogist.closed.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumLogist.accept.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма бонус, руб</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма бонус, руб</small>
                                </div>
                                <div class="col text-muted mt-2">
                                  <small>Сумма бонус, руб</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumBonus.total.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumBonus.closed.toFixed(2) }}</small>
                                </div>
                                <div class="col text-muted">
                                  <small>{{ detail.result.sumBonus.accept.toFixed(2) }}</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h3 v-if="false" class="text-center">Передано ФБ подробно</h3>
      <table v-if="false" class="table fs-8">
        <thead>
          <tr>
            <th>
              <span v-if="selectedBerry">
                Оптовик
              </span>
              <span v-else>
                Ягода
              </span>
            </th>
            <th>Вес сухой, кг</th>
            <th>Средняя цена, руб</th>
            <th>Сумма, руб</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(berry, index) in report" :key="index">
            <td>
              <button
                class="btn btn-light"
                @click="changeCurrentBerry(berry)"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="`#berry-${berry.berryId}`"
                aria-expanded="true"
                :aria-controls="`berry-${berry.berryId}`"
              >
                <span v-if="selectedBerry">
                  {{ berry.receiverLabel }}
                </span>
                <span v-else>
                  {{ berry.berryLabel }}
                </span>
              </button>
            </td>
            <td>{{ berry.resultTransfer.weightDry.toFixed(2) }}</td>
            <td>{{ berry.resultTransfer.priceAvg.toFixed(2) }}</td>
            <td>{{ berry.resultTransfer.sum.toFixed(2) }}</td>
          </tr>
          <tr class="fw-bold">
            <td>ИТОГО</td>
            <td>{{ reportSum.transferWeightDryTotal.toFixed(2) }}</td>
            <td>{{ reportSum.priceAvg.toFixed(2) }}</td>
            <td>{{ reportSum.sum.toFixed(2) }}</td>
          </tr>
          <tr>
            <td colspan="4">
              <div class="accordion fs-10" id="accordionExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingOne">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="`#berry-${currentBerry.berryId}`"
                      aria-expanded="true"
                      :aria-controls="`berry-${currentBerry.berryId}`"
                    >
                      <span>Подробный расчет: </span>

                      <span v-if="selectedBerry">
                        {{ currentBerry.receiverLabel }}
                      </span>
                      <span v-else>
                        {{ currentBerry.berryLabel }}
                      </span>
                    </button>
                  </h2>
                  <div
                    :id="`berry-${currentBerry.berryId}`"
                    class="accordion-collapse collapse"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div v-if="currentBerry" class="accordion-body">
                      <div
                        v-for="transfer in currentBerry.resultTransfer.transfers"
                        :key="transfer._id"
                        class="row"
                      >
                        <div class="row">
                          <router-link
                            :to="{
                              name: 'transfer',
                              params: { id: transfer._id }
                            }"
                          >
                            <span v-if="transfer.writeOff">Акт списания №</span>
                            <span v-if="!transfer.writeOff">Акт передачи №</span>
                            {{ transfer.prefix }}-{{ transfer.number }} от
                            {{ new Date(transfer.date).toLocaleString() }}
                          </router-link>
                        </div>
                        <div class="row">
                          <div class="row">
                            <div class="col text-muted lh-1">
                              <small>Вес сухой, кг</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>Цена, руб</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>Сумма, руб</small>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col text-muted lh-1">
                              <small>{{ transfer.tableUnit[0].weight }}</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>{{ transfer.tableUnit[0].price }}</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>{{
                                transfer.tableUnit[0].weight * transfer.tableUnit[0].price
                              }}</small>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col text-muted lh-1">
                              <small>Вес нераспред, кг</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>Цена нераспред, руб</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>Сумма нераспред, руб</small>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col text-muted lh-1">
                              <small>{{ transfer.weightManual }}</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>{{ transfer.priceManual }}</small>
                            </div>
                            <div class="col text-muted lh-1">
                              <small>{{ transfer.weightManual * transfer.priceManual }}</small>
                            </div>
                          </div>

                          <div class="accordion" :id="`accordion-transfer-${transfer._id}`">
                            <div class="accordion-item">
                              <h2 class="accordion-header" :id="`heading-transfer-${transfer._id}`">
                                <button
                                  class="accordion-button"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  :data-bs-target="`#transfer-${transfer._id}`"
                                  aria-expanded="true"
                                  :aria-controls="`transfer-${transfer._id}`"
                                >
                                  <small>РАСЧЕТ ЦЕНЫ</small>
                                </button>
                              </h2>
                              <div
                                :id="`transfer-${transfer._id}`"
                                class="accordion-collapse collapse"
                                :aria-labelledby="`heading-transfer-${transfer._id}`"
                                :data-bs-parent="`#accordion-transfer-${transfer._id}`"
                              >
                                <div class="accordion-body">
                                  <div class="row row-cols-1 pt-2">
                                    <div
                                      class="row"
                                      v-for="(detail, index) in transfer.details"
                                      :key="index"
                                    >
                                      <div class="row text-muted mt-1">
                                        <router-link
                                          v-if="detail.acceptanceId"
                                          :to="{
                                            name: 'acceptance',
                                            params: { id: detail.acceptanceId }
                                          }"
                                        >
                                          <small>{{ detail.acceptanceLabel }}</small>
                                        </router-link>
                                        <span v-else>{{ detail.acceptanceLabel }}</span>
                                      </div>
                                      <div v-if="false" class="row row-cols-3">
                                        <div class="col text-muted">
                                          <small>Ставка бонус, руб</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>Ставка логистика, руб</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>Общая усушка, %</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.rateTotal.bonus }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.rateTotal.logist }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.rateTotal.shrink }}</small>
                                        </div>

                                        <div class="col text-muted mt-2">
                                          <small>Всего</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Закрыто</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Принято</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Вес сухой, кг</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Вес сухой, кг</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Вес сухой, кг</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.weightDry.total.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.weightDry.closed.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.weightDry.accept.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Усушка, кг</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Усушка, кг</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Усушка, кг</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.weightShrink.total.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.weightShrink.closed.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.weightShrink.accept.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма всего, руб</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма всего, руб</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма всего, руб</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{ detail.result.sumDry.total.toFixed(2) }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.sumDry.closed.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.sumDry.accept.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма усушка, руб</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма усушка, руб</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма усушка, руб</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.sumShrink.total.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.sumShrink.closed.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.sumShrink.accept.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма логистика, руб</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма логистика, руб</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма логистика, руб</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.sumLogist.total.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.sumLogist.closed.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.sumLogist.accept.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма бонус, руб</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма бонус, руб</small>
                                        </div>
                                        <div class="col text-muted mt-2">
                                          <small>Сумма бонус, руб</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.sumBonus.total.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.sumBonus.closed.toFixed(2)
                                          }}</small>
                                        </div>
                                        <div class="col text-muted">
                                          <small>{{
                                            detail.result.sumBonus.accept.toFixed(2)
                                          }}</small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

import { async } from "q";

// import { onMounted, ref, computed } from "vue";
import useCommonMixin from "@/components/commonMixin.js";
import { useStore } from "vuex";
// import Multiselect from "@vueform/multiselect";

export default {
  name: "ReportMasterTable",

  //components: { Multiselect },
  props: {
    selectedBerry: String,
    report: Array,
    reportSum: Object,
    currentBerry: Object,
    showWriteoffBtn: { type: Boolean, default: false },
    dateTo: { type: String, default: "" },
    reloadReport: { type: Boolean, default: false }
  },

  setup(props, { emit }) {
    const changeCurrentBerry = value => {
      emit("update:current-berry", value);
    };

    const { isAdmin } = useCommonMixin();

    const store = useStore();

    const writeoffBalace = async reportRow => {
      let confirm = window.confirm(
        `Вы действительно хотите списать остаток ${reportRow.receiverLabel} - ${reportRow.berryLabel} - ${reportRow.resultAcceptance.weightDry.balance}?`
      );
      if (!confirm) {
        return;
      }

      reportRow.spinnerWriteoffBalace = true;

      let writeoffData = {
        berryId: reportRow.berryId,
        receiverId: reportRow.receiverId,
        weight: reportRow.resultAcceptance.weightDry.balance,
        docDate: props.dateTo.value
      };

      let response = await store.dispatch("POSTWriteoffBalance", writeoffData);

      if (response.status) {
        reportRow.spinnerWriteoffBalace = false;
        emit("update:reload-report", true);
      }
    };

    return {
      changeCurrentBerry,
      writeoffBalace,
      isAdmin,
    };
  }
};
</script>

<style>
.fs-8 {
  font-size: 0.8rem !important;
}

.fs-10 {
  font-size: 1rem !important;
}
</style>
